<template>
  <div class="tl">
    <Breadcrumbs main="Команды" title="Список команд"/>

    <Modal name="BanTeam" title="Бан команды" v-model="isShowBanTeamModal"
           :params="{ id: selectedTeamId, lang: selectedCaptainLang }"/>

    <div class="container-fluid tl-container">

      <!-- ================== TOOLBAR ================== -->
      <div class="tl-toolbar">
        <div class="tl-toolbar__main">
          <div class="tl-search" :class="{ 'is-busy': isLoadingTeams }">
            <i class="fa fa-search tl-search__icon"></i>
            <input
                ref="search"
                type="search"
                class="tl-search__input"
                v-model="searchModel"
                placeholder="ID, название, почта или username капитана…"
                @keydown.esc.prevent="clearSearch"
            />
            <button v-if="searchModel" type="button" class="tl-search__clear" @click="clearSearch">
              <i class="fa fa-times"></i>
            </button>
            <kbd v-else class="tl-search__kbd">/</kbd>
          </div>

          <b-dropdown variant="link" class="tl-drop" no-caret menu-class="tl-drop__menu">
            <template #button-content>
              <span class="tl-drop__btn" :class="{ 'is-on': !!activeGame }">
                <i class="fa fa-gamepad"></i>
                <span class="tl-drop__btn-text">{{ activeGame ? activeGame.text : 'Дисциплина' }}</span>
                <i class="fa fa-angle-down"></i>
              </span>
            </template>
            <b-dropdown-item @click="setGame(null)">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': !!activeGame }"></i> Все дисциплины
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item v-for="game in games" :key="'g' + game.value" @click="setGame(game.value)">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': !isSameId(activeGameId, game.value) }"></i>
              {{ game.text }}
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown variant="link" class="tl-drop" no-caret menu-class="tl-drop__menu">
            <template #button-content>
              <span class="tl-drop__btn" :class="{ 'is-on': teamTypeFilter !== 'all' }">
                <i class="fa fa-star-o"></i>
                <span class="tl-drop__btn-text">{{ teamTypeFilter === 'pro' ? 'PRO-команды' : 'Тип команды' }}</span>
                <i class="fa fa-angle-down"></i>
              </span>
            </template>
            <b-dropdown-item @click="setTeamType('all')">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': teamTypeFilter !== 'all' }"></i> Все команды
            </b-dropdown-item>
            <b-dropdown-item @click="setTeamType('pro')">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': teamTypeFilter !== 'pro' }"></i> Только PRO
            </b-dropdown-item>
          </b-dropdown>

          <div class="tl-spacer"></div>

          <div class="tl-seg" role="group" aria-label="Вид">
            <button type="button" class="tl-seg__btn" :class="{ 'is-on': viewMode === 'table' }"
                    @click="setViewMode('table')" v-b-tooltip.hover.bottom="'Таблица'">
              <i class="fa fa-list-ul"></i>
            </button>
            <button type="button" class="tl-seg__btn" :class="{ 'is-on': viewMode === 'grid' }"
                    @click="setViewMode('grid')" v-b-tooltip.hover.bottom="'Карточки'">
              <i class="fa fa-th-large"></i>
            </button>
          </div>

          <button type="button" class="tl-icon-btn" :class="{ 'is-on': density === 'compact' }"
                  @click="toggleDensity" v-b-tooltip.hover.bottom="'Плотность строк'">
            <i class="fa fa-bars"></i>
          </button>

          <b-dropdown v-if="viewMode === 'table'" variant="link" class="tl-drop" no-caret
                      right menu-class="tl-drop__menu" toggle-class="p-0">
            <template #button-content>
              <span class="tl-icon-btn" v-b-tooltip.hover.bottom="'Колонки'"><i class="fa fa-columns"></i></span>
            </template>
            <b-dropdown-form class="tl-cols">
              <div class="tl-cols__title">Колонки таблицы</div>
              <b-form-checkbox v-for="col in togglableColumns" :key="'c' + col.key"
                               :checked="visibleCols.includes(col.key)"
                               @change="toggleColumn(col.key)"
                               class="tl-cols__item">
                {{ col.label }}
              </b-form-checkbox>
              <button type="button" class="tl-cols__reset" @click="resetColumns">Сбросить</button>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown variant="link" class="tl-drop" no-caret right menu-class="tl-drop__menu" toggle-class="p-0">
            <template #button-content>
              <span class="tl-icon-btn" v-b-tooltip.hover.bottom="'Другие списки'"><i class="fa fa-ellipsis-h"></i></span>
            </template>
            <b-dropdown-item :to="{ name: 'deleted_teams' }">
              <i class="fa fa-archive tl-drop__check"></i> Удалённые команды
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'teams_fake' }">
              <i class="fa fa-user-secret tl-drop__check"></i> Фейковые команды
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ban_teams' }">
              <i class="fa fa-ban tl-drop__check"></i> Забаненные команды
            </b-dropdown-item>
          </b-dropdown>

          <button type="button" class="tl-icon-btn" :class="{ 'is-spin': isLoadingTeams }"
                  @click="refresh" v-b-tooltip.hover.bottom="'Обновить'">
            <i class="fa fa-refresh"></i>
          </button>

        </div>

        <div v-if="hasAnyRefine" class="tl-chips">
          <span class="tl-chips__label">Фильтры:</span>

          <button v-if="searchApplied" type="button" class="tl-chip" @click="clearSearch">
            <i class="fa fa-search"></i> «{{ searchApplied }}» <i class="fa fa-times tl-chip__x"></i>
          </button>

          <button v-if="activeGame" type="button" class="tl-chip" @click="setGame(null)">
            <i class="fa fa-gamepad"></i> {{ activeGame.text }} <i class="fa fa-times tl-chip__x"></i>
          </button>

          <button v-if="teamTypeFilter === 'pro'" type="button" class="tl-chip" @click="setTeamType('all')">
            <i class="fa fa-star-o"></i> PRO-команды <i class="fa fa-times tl-chip__x"></i>
          </button>

          <button type="button" class="tl-chips__reset" @click="resetAll">Сбросить всё</button>
        </div>
      </div>

      <!-- ================== CONTENT ================== -->
      <div class="tl-panel" :class="['tl-panel--' + density]">

        <!-- skeleton -->
        <div v-if="isLoadingTeams" class="tl-skeleton">
          <div v-for="n in 8" :key="'sk' + n" class="tl-skeleton__row">
            <span class="tl-sk tl-sk--avatar"></span>
            <span class="tl-sk tl-sk--wide"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk tl-sk--sm"></span>
          </div>
        </div>

        <!-- empty -->
        <div v-else-if="!rows.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-users"></i></div>
          <div class="tl-empty__title">
            {{ hasAnyRefine ? 'Ничего не нашлось' : 'Команд пока нет' }}
          </div>
          <div class="tl-empty__text">
            {{ hasAnyRefine
              ? 'Попробуйте изменить условия поиска или сбросить фильтры.'
              : 'Команды появляются здесь после регистрации капитанами на сайте.' }}
          </div>
          <div v-if="hasAnyRefine" class="tl-empty__actions">
            <button type="button" class="tl-btn-ghost-2" @click="resetAll">Сбросить фильтры</button>
          </div>
        </div>

        <!-- table -->
        <div v-else-if="viewMode === 'table'" class="tl-table-wrap">
          <b-table
              ref="table"
              class="tl-table"
              responsive
              hover
              borderless
              show-empty
              :items="rows"
              :fields="activeFields"
              :tbody-tr-class="rowClass"
              @row-clicked="openTeam"
          >
            <template #cell(id)="{ item }">
              <button type="button" class="tl-id" @click.stop="copyId(item.id)"
                      v-b-tooltip.hover.right="'Скопировать ID'">
                <span>#{{ item.id }}</span>
                <i class="fa fa-copy"></i>
              </button>
            </template>

            <template #cell(name)="{ item }">
              <div class="tl-name">
                <span class="tl-name__logo" :style="logoStyle(item)">
                  <template v-if="!logoUrl(item)">{{ initials(item.name) }}</template>
                </span>
                <div class="tl-name__col">
                  <button type="button" class="tl-name__title" @click.stop="openTeam(item)" :title="item.name">
                    {{ item.name }}
                  </button>
                  <div class="tl-name__marks">
                    <span v-if="item.x_pro" class="tl-tag tl-tag--pro">PRO</span>
                    <span v-if="item.x_banned" class="tl-tag tl-tag--ban">
                      <i class="fa fa-ban"></i> Бан
                    </span>
                  </div>
                </div>
              </div>
            </template>

            <template #cell(captain)="{ item }">
              <div v-if="item.x_captain" class="tl-time">
                <span class="tl-time__abs">{{ item.x_captain }}</span>
                <span v-if="item.x_captainLang" class="tl-time__rel">{{ item.x_captainLang.toUpperCase() }}</span>
              </div>
              <span v-else class="tl-muted">—</span>
            </template>

            <template #cell(members)="{ item }">
              <span class="tl-pill">{{ item.member_count || 0 }}</span>
            </template>

            <template #cell(tournaments)="{ item }">
              <span class="tl-muted-strong">{{ item.tournaments_count || 0 }}</span>
            </template>

            <template #cell(last_tournament)="{ item }">
              <div v-if="item.x_lastTournament" class="tl-time">
                <span class="tl-time__abs">{{ formatDate(item.x_lastTournament) }}</span>
                <span class="tl-time__rel" :class="relClass(item.x_lastTournament)">
                  {{ formatRelative(item.x_lastTournament) }}
                </span>
              </div>
              <span v-else class="tl-muted">не играла</span>
            </template>

            <template #cell(game)="{ item }">
              <span class="tl-muted-strong">{{ item.x_game || '—' }}</span>
            </template>

            <template #cell(created)="{ item }">
              <div class="tl-time">
                <span class="tl-time__abs">{{ formatDate(item.created_at) }}</span>
                <span class="tl-time__rel">{{ formatRelative(item.created_at) }}</span>
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="tl-actions" @click.stop>
                <button type="button" class="tl-act" @click="openTeam(item)"
                        v-b-tooltip.hover.top="'Открыть карточку'">
                  <i class="fa fa-eye"></i>
                </button>
                <button v-if="item.x_banned" type="button" class="tl-act tl-act--warn"
                        @click="unbanTeam(item)" v-b-tooltip.hover.top="'Снять бан'">
                  <i class="fa fa-unlock"></i>
                </button>
                <button v-else type="button" class="tl-act tl-act--danger"
                        @click="openBanModal(item)" v-b-tooltip.hover.top="'Забанить'">
                  <i class="fa fa-ban"></i>
                </button>
              </div>
            </template>

            <template #empty>
              <div class="tl-empty tl-empty--inline">Ничего не найдено</div>
            </template>
          </b-table>
        </div>

        <!-- grid -->
        <div v-else class="tl-grid">
          <article v-for="item in rows" :key="'card' + item.id" class="tl-card" @click="openTeam(item)">
            <header class="tl-card__head">
              <span class="tl-card__logo" :style="logoStyle(item)">
                <template v-if="!logoUrl(item)">{{ initials(item.name) }}</template>
              </span>
              <div class="tl-card__headtext">
                <button type="button" class="tl-card__title" @click.stop="openTeam(item)" :title="item.name">
                  {{ item.name }}
                </button>
                <div class="tl-card__sub">
                  <span class="tl-id tl-id--sm">#{{ item.id }}</span>
                  <span class="tl-dot-sep">·</span>
                  <span>{{ item.x_game || '—' }}</span>
                  <span v-if="item.x_pro" class="tl-tag tl-tag--pro">PRO</span>
                  <span v-if="item.x_banned" class="tl-tag tl-tag--ban"><i class="fa fa-ban"></i> Бан</span>
                </div>
              </div>
            </header>

            <div class="tl-card__rows">
              <div class="tl-card__row">
                <span><i class="fa fa-user-o tl-muted"></i> Капитан</span>
                <span class="tl-muted-strong">{{ item.x_captain || '—' }}</span>
              </div>
              <div class="tl-card__row">
                <span><i class="fa fa-users tl-muted"></i> Участников</span>
                <span class="tl-muted-strong">{{ item.member_count || 0 }}</span>
              </div>
              <div class="tl-card__row">
                <span><i class="fa fa-trophy tl-muted"></i> Турниров</span>
                <span class="tl-muted-strong">{{ item.tournaments_count || 0 }}</span>
              </div>
              <div class="tl-card__row">
                <span><i class="fa fa-clock-o tl-muted"></i> Последний турнир</span>
                <span class="tl-muted-strong">
                  {{ item.x_lastTournament ? formatDate(item.x_lastTournament) : 'не играла' }}
                </span>
              </div>
            </div>

            <footer class="tl-card__foot" @click.stop>
              <button type="button" class="tl-act" @click="openTeam(item)" v-b-tooltip.hover.top="'Открыть карточку'">
                <i class="fa fa-eye"></i>
              </button>
              <span class="tl-spacer"></span>
              <button v-if="item.x_banned" type="button" class="tl-act tl-act--warn"
                      @click="unbanTeam(item)" v-b-tooltip.hover.top="'Снять бан'">
                <i class="fa fa-unlock"></i>
              </button>
              <button v-else type="button" class="tl-act tl-act--danger"
                      @click="openBanModal(item)" v-b-tooltip.hover.top="'Забанить'">
                <i class="fa fa-ban"></i>
              </button>
            </footer>
          </article>
        </div>

        <!-- footer / pagination -->
        <div v-if="!isLoadingTeams && rows.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ rangeFrom }}–{{ rangeTo }}</b> из <b>{{ total || 0 }}</b>
          </div>
          <b-pagination
              class="tl-pagination my-0"
              v-model="currentPageModel"
              :total-rows="total"
              :per-page="perPage"
              :limit="7"
              @change="goToPage"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {TeamsAdapterMixin} from "@/mixins/Teams/TeamsAdapterMixin";
import {TeamBanAdapterMixin} from "@/mixins/TeamBan/TeamBanAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import Modal from '@/components/modals/index.vue'

const LS = {
  view: "teamsListView",
  density: "teamsListDensity",
  columns: "teamsListColumns",
};

const ALL_COLUMNS = [
  {key: "id", label: "ID", fixed: true},
  {key: "name", label: "Команда", fixed: true},
  {key: "captain", label: "Капитан"},
  {key: "members", label: "Участников"},
  {key: "tournaments", label: "Турниров"},
  {key: "last_tournament", label: "Последний турнир"},
  {key: "game", label: "Дисциплина"},
  {key: "created", label: "Создана"},
  {key: "action", label: "", fixed: true},
];

const DEFAULT_COLUMNS = ["captain", "members", "tournaments", "last_tournament", "game", "created"];

export default {
  name: 'TeamsList',
  components: {Modal},
  mixins: [TeamsAdapterMixin, TeamBanAdapterMixin, PaginationHelperMixin],
  data() {
    return {
      pageKey: 'pageNumberTeamList',
      perPage: 10,

      searchModel: "",
      searchApplied: "",
      searchTimer: null,

      activeGameId: null,
      teamTypeFilter: 'all',

      viewMode: 'table',
      density: 'cozy',
      visibleCols: [...DEFAULT_COLUMNS],

      isShowBanTeamModal: false,
      selectedTeamId: null,
      selectedCaptainLang: null,
    }
  },
  computed: {
    activeGame() {
      if (this.activeGameId === null) return null;
      return (this.games || []).find(game => this.isSameId(game.value, this.activeGameId)) || null;
    },

    hasAnyRefine() {
      return Boolean(this.searchApplied) || this.activeGameId !== null
          || this.teamTypeFilter !== 'all';
    },

    /** Строки таблицы с производными полями — чтобы шаблон не лез в глубокие цепочки. */
    rows() {
      return (this.teams || []).map(team => ({
        ...team,
        x_banned: Boolean(team.currentBans && team.currentBans.length),
        x_banId: team.currentBans && team.currentBans.length ? team.currentBans[0].id : null,
        x_pro: Boolean(team.division && team.division.id === 5),
        x_game: (team.game && team.game.name) || "",
        x_captain: (team.teamOwner && team.teamOwner.email)
            || (team.captain && (team.captain.email || team.captain.username)) || "",
        x_captainLang: (team.captain && team.captain.lang && team.captain.lang.code) || "",
        x_lastTournament: (team.lastTournament && team.lastTournament.created_at) || null,
      }));
    },

    togglableColumns() {
      return ALL_COLUMNS.filter(col => !col.fixed);
    },

    activeFields() {
      return ALL_COLUMNS
          .filter(col => col.fixed || this.visibleCols.includes(col.key))
          .map(col => ({
            key: col.key,
            label: col.label,
            sortable: !["action", "id"].includes(col.key),
            thClass: col.key === "action" ? "tl-th--act" : "",
            tdClass: col.key === "action" ? "tl-td--act" : "",
          }));
    },

    currentPageModel: {
      get() {
        return Number(this.currentPage) || 1;
      },
      set(value) {
        this.currentPage = value;
      },
    },

    rangeFrom() {
      if (!this.total) return 0;
      return (this.currentPageModel - 1) * this.perPage + 1;
    },

    rangeTo() {
      return Math.min(this.currentPageModel * this.perPage, this.total || 0);
    },
  },
  watch: {
    searchModel(value) {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (this.searchApplied === value.trim()) return;
        this.searchApplied = value.trim();
        this.currentPage = 1;
        this.fetchTeams();
      }, 400);
    },
  },
  async mounted() {
    this.restorePreferences();
    this.currentPage = Number(this.getCurrentPageNumber(this.pageKey)) || 1;

    await this.fetchTeams();
    await this.grabGamesForTeams();

    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  methods: {
    // ------------------------------------------------ данные
    async fetchTeams() {
      this.isLoadingTeams = true;
      this.recordPageToStorage(this.currentPageModel, this.pageKey);
      try {
        await this.indexTeams({
          pageNumber: this.currentPageModel,
          ...(this.searchApplied && {search: this.searchApplied}),
          ...(this.activeGameId !== null && {gameId: this.activeGameId}),
          ...(this.teamTypeFilter === 'pro' && {divisionId: 5}),
        });
      } catch (e) {
        this.$toasted.error("Не удалось загрузить команды", {position: 'top-right', duration: 3000});
      } finally {
        this.isLoadingTeams = false;
      }
    },

    refresh() {
      this.fetchTeams();
    },

    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.$nextTick(this.fetchTeams);
    },

    // ------------------------------------------------ фильтры
    setGame(gameId) {
      this.activeGameId = gameId;
      this.currentPage = 1;
      this.fetchTeams();
    },

    setTeamType(type) {
      this.teamTypeFilter = type;
      this.currentPage = 1;
      this.fetchTeams();
    },

    clearSearch() {
      this.searchModel = "";
      if (!this.searchApplied) return;
      this.searchApplied = "";
      this.currentPage = 1;
      this.fetchTeams();
    },

    resetAll() {
      this.searchModel = "";
      this.searchApplied = "";
      this.activeGameId = null;
      this.teamTypeFilter = 'all';
      this.currentPage = 1;
      this.fetchTeams();
    },

    isSameId(a, b) {
      return a !== null && b !== null && String(a) === String(b);
    },

    // ------------------------------------------------ действия
    openTeam(item) {
      this.showTeamInfo(item.id);
    },

    openBanModal(item) {
      this.selectedTeamId = item.id;
      this.selectedCaptainLang = item.x_captainLang ? item.x_captainLang : 'Не указан';
      this.isShowBanTeamModal = true;
    },

    async unbanTeam(item) {
      if (!item.x_banId) return;
      await this.deleteTeamBan({teamId: item.x_banId});
      this.$toasted.success(`Бан с «${item.name}» снят`, {position: 'top-right', duration: 2500});
      // стор перезапрашивает список без фильтров — возвращаем свои
      this.fetchTeams();
    },

    copyId(id) {
      const done = () => this.$toasted.success(`ID ${id} скопирован`, {position: 'top-right', duration: 1500});
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(String(id)).then(done).catch(() => {
        });
        return;
      }
      const area = document.createElement("textarea");
      area.value = String(id);
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand("copy");
        done();
      } finally {
        document.body.removeChild(area);
      }
    },

    // ------------------------------------------------ вид
    restorePreferences() {
      try {
        const view = localStorage.getItem(LS.view);
        if (view === "grid" || view === "table") this.viewMode = view;

        const density = localStorage.getItem(LS.density);
        if (density === "compact" || density === "cozy") this.density = density;

        const columns = JSON.parse(localStorage.getItem(LS.columns) || "null");
        if (Array.isArray(columns)) this.visibleCols = columns;
      } catch (e) { /* повреждённые настройки — берём значения по умолчанию */
      }
    },

    setViewMode(mode) {
      this.viewMode = mode;
      localStorage.setItem(LS.view, mode);
    },

    toggleDensity() {
      this.density = this.density === "compact" ? "cozy" : "compact";
      localStorage.setItem(LS.density, this.density);
    },

    toggleColumn(key) {
      this.visibleCols = this.visibleCols.includes(key)
          ? this.visibleCols.filter(col => col !== key)
          : [...this.visibleCols, key];
      localStorage.setItem(LS.columns, JSON.stringify(this.visibleCols));
    },

    resetColumns() {
      this.visibleCols = [...DEFAULT_COLUMNS];
      localStorage.setItem(LS.columns, JSON.stringify(this.visibleCols));
    },

    rowClass(item) {
      return item && item.x_banned ? "tl-row--banned" : "";
    },

    // ------------------------------------------------ отображение
    logoUrl(item) {
      return (item.logo && item.logo.original_url) || "";
    },

    logoStyle(item) {
      const url = this.logoUrl(item);
      return url ? {backgroundImage: `url(${url})`} : {};
    },

    initials(name) {
      if (!name) return "?";
      return String(name).trim().slice(0, 2).toUpperCase();
    },

    formatDate(value) {
      if (!value) return "—";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "—";
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    formatRelative(value) {
      if (!value) return "";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "";
      const days = Math.round((Date.now() - date.getTime()) / 86400000);
      if (days <= 0) return "сегодня";
      if (days === 1) return "вчера";
      if (days < 30) return `${days} дн. назад`;
      const months = Math.round(days / 30);
      if (months < 12) return `${months} мес. назад`;
      return `${Math.round(months / 12)} г. назад`;
    },

    relClass(value) {
      if (!value) return "";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "";
      return Date.now() - date.getTime() > 180 * 86400000 ? "is-past" : "";
    },

    onKeydown(event) {
      const tag = (event.target && event.target.tagName) || "";
      const isTyping = /INPUT|TEXTAREA|SELECT/.test(tag) || (event.target && event.target.isContentEditable);

      if (event.key === "Escape") {
        if (isTyping) return;
        if (this.hasAnyRefine) this.resetAll();
        return;
      }

      if (isTyping || event.ctrlKey || event.metaKey || event.altKey) return;

      if (event.key === "/") {
        event.preventDefault();
        if (this.$refs.search) this.$refs.search.focus();
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";

/* ---------- специфика списка команд ---------- */
.tl-name__col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.tl-name__title,
.tl-card__title {
  border: 0;
  background: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.tl-name__marks {
  display: flex;
  align-items: center;
  gap: 5px;
}

.tl-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .03em;

  &--pro {
    background: rgba(245, 179, 1, .16);
    color: #a97900;
  }

  &--ban {
    background: var(--tl-danger);
    color: #fff;
    font-weight: 600;
  }
}

.tl-act--warn:hover {
  border-color: var(--tl-warn);
  background: rgba(240, 160, 32, .12);
  color: var(--tl-warn) !important;
}

.tl-table ::v-deep tbody tr.tl-row--banned td {
  background: rgba(224, 65, 79, .05);
}

.tl-table ::v-deep tbody tr.tl-row--banned:hover td {
  background: rgba(224, 65, 79, .09);
}
</style>
